<template>
	<div>
		<case-form :schema="caseSchema" />
	</div>
</template>

<script>
import CaseForm from "../../CaseForm/CaseForm.vue"

export default {
	name: "PJProposalOverview",
	components: { CaseForm },
	data() {
		return {
			caseSchema: [
				{
					label: "Currency Code",
					component: "select",
					bindTo: "case.facts.currencyCode",
					props: {
						options: [
							{
								name: "Australian Dollar",
								value: "AUD"
							},
							{
								name: "Canadian Dollar",
								value: "CAD"
							},
							{
								name: "European Dollar",
								value: "EUR"
							},
							{
								name: "Pound Sterling",
								value: "GBP"
							},
							{
								name: "Hong Kong Dollar",
								value: "HKD"
							},
							{
								name: "US Dollar",
								value: "USD"
							},
							{
								name: "Japanese Yen",
								value: "JPY"
							},
							{
								name: "New Taiwan Dollar",
								value: "NTD"
							},
							{
								name: "Renminbi",
								value: "RMB"
							},
							{
								name: "Singaporean Dollar",
								value: "SGD"
							},
							{
								name: "Thai BAHT",
								value: "THB"
							}
						]
					}
				},
				{
					label: "Sign Date",
					component: "date",
					bindTo: "case.facts.signDate"
				}
			]
		}
	}
}
</script>
